<template>
  <VueSlickCarousel v-bind="settings">
    <slot></slot>
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'

export default {
  props: ['slidesToShowLg', 'slidesToShowMd', 'slidesToShowSm', 'showDots', 'auto'],
  components: { VueSlickCarousel },
  data() {
    return {
      loading: true,
      settings: {
        autoplay: this.auto || false,
        autoplaySpeed: 2500,
        dots: this.showDots || false,
        infinite: true,
        speed: 500,
        slidesToShow: this.slidesToShowLg || 3,
        slidesToScroll: 1,
        initialSlide: 0,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: this.slidesToShowMd || 2,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: this.slidesToShowSm || 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            },
          },
        ],
      },
    }
  },
}
</script>
